import React from 'react';
import { StyledBody } from '../../CSSstyles';

const ClinicProvideInfoBulletPoint = () => (
  <li>
    <StyledBody>The clinic will provide information on how you'll receive your results.</StyledBody>
  </li>
);

ClinicProvideInfoBulletPoint.propTypes = {};

export default ClinicProvideInfoBulletPoint;
